import { useEffect, useState } from "react";
import { subscribe } from "../services/loadingService";

export default function GlobalLoader() {

  const [loading, setLoadingState] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribe(setLoadingState);
    return unsubscribe;
  }, []);

  if (!loading) return null;

  return (
    <div className="global-loader">
      <div className="spinner"></div>
    </div>
  );
}
